// extracted by mini-css-extract-plugin
export default {"wrapper":"Highlights_wrapper__2sXzy","value":"Highlights_value__Nuqx9","title":"Highlights_title__sUygb"};